import { render } from "./CreateSalary.vue?vue&type=template&id=0dffce6a"
import script from "./CreateSalary.vue?vue&type=script&lang=js"
export * from "./CreateSalary.vue?vue&type=script&lang=js"

import exportComponent from "/Applications/MAMP/htdocs/fprint/e-transaksi/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__